import React from "react";
import "./style.scss";

import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutSteps from "../Shared/LayoutSteps";

import { ContextDefault } from "./../../context/Provider";

const EducacaoJuridica = () => {
  const context = React.useContext(ContextDefault);

  React.useEffect(() => {
    context.actions.setProgressBarVisiblity(false);
  }, [context.actions]);

  return (
    <LayoutSteps className="wrapper-juridica" renderButtom={props => <Buttom data-class="btn-donation--default" {...props} />}>
      <div className="container">
        <Title className="title">Pessoa Juridíca</Title>
        <p>Pessoas jurídicas que queiram apoiar nossos projetos a dedução é de até 1% na Lei Federal (Nº 11.438/06) ou até 3%* do ICMS na Lei Paulista de Incentivo ao Esporte (Lei Nº 13.918/09).</p>
        <p>
          Para saber mais como apoiar, envie um e-mail para &nbsp;
          <a href="maito:apoie@institutopeninsula.org.br">apoie@institutopeninsula.org.br</a>
        </p>
      </div>
    </LayoutSteps>
  );
};

export default EducacaoJuridica;
